export const loginModel = {
    showPassword: false,
    email: "",
    password: "",

    togglePasswordVisible() {
        this.showPassword = !this.showPassword;
    },

    setEmail(email) {
        this.email = email;
    },

    setPassword(password) {
        this.password = password;
    }
}